import clsx from 'clsx';
import React from 'react';

import Button from '@components/Button';
import IconPlus from '@components/Images/Rebranding/IconPlus';

interface MenuLinkProps {
  as: 'link' | 'button';
  href?: string;
  isMenuOpen?: boolean;
  isPro?: boolean;
  name: string;
  onClick?: () => void;
  onClickCapture?: () => void;
}

const MenuLink = ({
  as,
  href,
  isMenuOpen = false,
  isPro,
  name,
  onClick,
  onClickCapture,
}: MenuLinkProps) => {
  return (
    <Button
      as={as}
      className={clsx('flex items-center border-0 bg-transparent p-0', {
        'text-pro-gold': isMenuOpen && isPro,
        'text-primary-magenta': isMenuOpen && !isPro,
        'text-white': !isMenuOpen,
      })}
      onClick={onClick}
      onClickCapture={onClickCapture}
      href={href}
    >
      <IconPlus
        className={clsx('mr-20 w-16 transition-all duration-300 ease-in', {
          'rotate-[135deg]': isMenuOpen,
          'rotate-0': !isMenuOpen,
        })}
      />
      <span
        className={clsx('font-suisse-intl-mono text-headline-xs font-bold', {
          'border-0 border-b-2 border-solid': isMenuOpen,
          'border-0': !isMenuOpen,
        })}
      >
        {name}
      </span>
    </Button>
  );
};

export default MenuLink;
